"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/**
 * @ignore - internal component.
 */


var FormControlContext = _react.default.createContext();

var _default = FormControlContext;
exports.default = _default;